import { gql } from "@apollo/client";

export const MUTATION_MARK_NOTIFICATION_CLICKED = gql`
  mutation markNotificationClicked(
    $documentId: ID!
    $data: NotificationUserInput!
  ) {
    updateNotificationUser(documentId: $documentId, data: $data) {
      documentId
      clickedAt
      seenAt
      deliveredAt
    }
  }
`;

export const MUTATION_MARK_NOTIFICATION_SEEN = gql`
  mutation markNotificationSeen(
    $documentId: ID!
    $data: NotificationUserInput!
  ) {
    updateNotificationUser(documentId: $documentId, data: $data) {
      documentId
      clickedAt
      seenAt
      deliveredAt
    }
  }
`;

export const MUTATION_CREATE_NOTIFICATION_USER = gql`
  mutation createNotificationUser($data: NotificationUserInput!) {
    createNotificationUser(data: $data) {
      documentId
      deliveredAt
      clickedAt
      seenAt
      notification {
        documentId
      }
      user {
        documentId
      }
    }
  }
`;
